export default function (value) {
    const valueType = typeof value;

    if (valueType !== "number") {
        const numberValue = Number(value);

        if (isNaN(numberValue)) {
            return value;
        }

        value = numberValue;
    }

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
    });

    return formatter.format(value);
}